module.exports = __webpack_public_path__ + "img/icons_connect-left-or.6f15f789.svg";